import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function Modal({ isOpen, onClose, title, children, large, withoutLogo }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Disable scroll
    } else {
      document.body.style.overflow = ""; // Restore scroll
    }

    // Cleanup, in case component unmounts
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-block position-fixed top-0 start-0 w-100 h-100 d-flex bg-opacity-50 justify-content-end"
      id="ebookModal"
      style={{ zIndex: 1050 }}
      onClick={onClose}
    >
      <button className="modal-close" onClick={onClose}>
        <img src="/assets/images/icons/close-icon.svg" alt="close" />
      </button>

      <div
        className={`modal-content-wrapper bg-white shadow ${
          large ? "large" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={`modal-content ${large ? "large" : ""}`}
          style={{ zIndex: 1055 }}
        >
          <div className="modal-header">
            {!withoutLogo ? (
              <>
                <div className="logo" >
                  <div className="link white-version">
                    <img src="/assets/images/logo/logo-two.png" alt="Logo"  />
                  </div>
                  <div className="link dark-version">
                    <img
                      src="/assets/images/logo/white-logo.png"
                      alt="Logo"
                    />
                  </div>
                </div>
              </>
            ) : null}
            {title && (
              <h4 className="modal-title mb-48">{title}</h4>
            )}
          </div>

          <div className="modal-body">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
